import { createSelector } from "reselect";

const getKaviar = (state) =>
  state.variantResult && state.variantResult.isb_kaviar3;

const kaviarListSelector = createSelector(getKaviar, (items) => {
  if (items) {
    const date = new Date().getTime();
    return items.map((x, i) => {
      const acArray = [];
      const anArray = [];
      x.ac.forEach((y, j) => {
        acArray.push({
          value: y,
          id: `${j}${date}`,
        });
      });
      x.an.forEach((y, j) => {
        anArray.push({
          value: y,
          id: `${j}${date}`,
        });
      });
      return {
        ...x,
        ac: acArray,
        an: anArray,
        id: `${i}${date}`,
      };
    });
  }
  return null;
});

export { getKaviar, kaviarListSelector };
